<template>
  <div class="recordBox" @click="toDetail">
    <div class="top">
      <p class="time">{{ lang('兑换时间') }}: {{ props.data.redeemTime }}</p>
      <div
        class="status"
        :style="materialStatus(props.data.applyStatus).boxStyle"
      >
        <p class="statusText">
          {{ materialStatus(props.data.applyStatus).name }}
        </p>
      </div>
    </div>
    <div class="main">
      <img :src="props.data?.materialPhoto || ''" @error="setDefaultImage" />
      <div class="right">
        <div class="nameBox">
          <p class="name" style="flex: 1">
            {{ props.data?.materialName || '' }}
          </p>
          <p class="name" style="font-weight: 600">
            X{{ props.data?.quantity || '1' }}
          </p>
        </div>
        <div class="bottom">
          <div class="scoreBox">
            <img src="@/assets/images/score/blackBase.png" />
            <p class="score">{{ props.data.redeemPoints }}</p>
          </div>
          <van-button
            v-if="btn(props.data.applyStatus)?.name"
            class="btnBox"
            :style="btn(props.data.applyStatus).style"
            round
            :plain="true"
            @click="click($event, props.data.id, props.data.applyStatus)"
          >
            {{ btn(props.data.applyStatus).name }}
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()
import { MaterialRedeemResp } from '@/model/score/score'
import { arrived, cancelExchange } from '@/api/requests/score'
import { showToast } from 'vant'
import lang from '@/langs'
import { showDialog } from 'vant'
import { materialStatus } from '@/views/score/utils/status'
import img_failed from '@/assets/images/score/img_failed.png'
import { getPhoto } from '@core/utils/nativeAPI'
import { uploadFile } from '@/utils/imageUpload'
const setDefaultImage = (event) => {
  event.target.src = img_failed
}
const props = defineProps<{ data: MaterialRedeemResp }>()
const emits = defineEmits(['refreshList', 'confirm'])
const toDetail = () => {
  router.push({ path: '/orderScoreDetail', query: { data: props.data.id } })
}
const btn = (type: number) => {
  if (type === 5) {
    return {
      name: lang('确认送达'),
      key: 'confirm',
      style: {
        background:
          'linear-gradient( 90deg,rgba(250, 81, 15, 1),rgba(255, 0, 0, 1))',
        color: '#fff'
      }
    }
  } else if (type === 1) {
    return {
      name: lang('取消兑换'),
      key: 'cancel',
      style: { background: '#fff', color: 'rgba(60, 60, 60, 1)' }
    }
  }
}

const click = (event, id: string, status: number) => {
  event.stopPropagation() // 阻止事件冒泡
  let msg
  if (status === 1) {
    msg = lang('是否取消兑换')
    showDialog({
      title: lang('提示'),
      message: msg,
      showCancelButton: true,
      confirmButtonColor: 'rgba(255, 0, 0, 1)',
      confirmButtonText: lang('确定'),
      cancelButtonText: lang('取消')
    })
      .then(() => {
        // on confirm
        if (status === 1) {
          cancelExchange({ id }).then((value) => {
            if (value.code === 1) {
              showToast(lang('取消兑换成功'))
              emits('refreshList')
            } else {
              showToast(
                lang(value?.msg) || ' Service exception, please try again later'
              )
            }
          })
        }
      })
      .catch(() => {
        // on cancel
      })
  } else {
    emits('confirm', id)
  }
}
</script>

<style scoped lang="less">
.recordBox {
  background: #fff;
  margin: 8px 10px;
  padding: 14px 11px;
  .top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 11px;
    align-items: center;
    .time {
      color: rgba(153, 153, 153, 1);
      font-size: 12px;
    }
    .status {
      border-radius: 3px;
      padding: 3px 4px;
      font-size: 12px;
    }
  }
  .main {
    display: flex;
    flex-direction: row;
    > img {
      width: 75px;
      height: 75px;
      margin-right: 11px;
    }
    .right {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow: hidden; /* 隐藏超出内容 */
      .nameBox {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .name {
          color: rgba(60, 60, 60, 1);
          font-size: 14px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; /* 限制显示 2 行 */
          overflow: hidden;
        }
      }
      .bottom {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 16px;
        .scoreBox {
          display: flex;
          flex-direction: row;
          align-items: center;
          > img {
            width: 10px;
            height: 10px;
            margin-right: 6px;
          }
          .score {
            font-size: 18px;
            font-weight: 500;
            color: rgba(60, 60, 60, 1);
          }
        }
        .btnBox {
          height: 30px;
          font-size: 14px;
          padding: 8px 15px;
        }
      }
    }
  }
}
</style>
